const getBookingLoading = (state, bookingReference) =>
  Boolean(state.booking.loading[bookingReference]);

export default getBookingLoading;
